import { $userLanguage } from '@/entities/user'
import { useUnit } from 'effector-react'
import {
  CaseRarityRu,
  CaseRarityEn,
  CaseTimeLimitatonEn,
  CaseTimeLimitatonRu,
  CaseTypeRu,
  CaseTypeEn,
} from '@/entities/cases'
import { useEffect, useState } from 'react'
import { useStyles } from './styles'

export const CaseSubNameText = ({ caseName, styles }: { caseName: string; styles?: React.CSSProperties }) => {
  const userLang = useUnit($userLanguage)
  const { classes } = useStyles()
  const [caseSubname, setCaseSubname] = useState({
    type: '',
    timeLimitation: '',
    rarity: '',
  })
  const type = CaseTypeEn[caseName as keyof typeof CaseTypeEn] ?? 'Standard Case'
  const caseRarity = CaseRarityEn[caseName as keyof typeof CaseRarityEn]

  useEffect(() => {
    if (userLang) {
      const isEnglish = userLang === 'en'
      setCaseSubname({
        type: isEnglish
          ? CaseTypeEn[caseName as keyof typeof CaseTypeEn]
          : CaseTypeRu[caseName as keyof typeof CaseTypeRu],
        timeLimitation: isEnglish
          ? CaseTimeLimitatonEn[caseName as keyof typeof CaseTimeLimitatonEn]
          : CaseTimeLimitatonRu[caseName as keyof typeof CaseTimeLimitatonRu],
        rarity: isEnglish
          ? CaseRarityEn[caseName as keyof typeof CaseRarityEn]
          : CaseRarityRu[caseName as keyof typeof CaseRarityRu],
      })
    }
  }, [userLang, caseName])
  if (!caseName) return <span></span>

  return (
    <div
      className={classes.root}
      style={styles}
    >
      <div>
        <span
          className={classes.type}
          data-type={type}
        >
          {caseSubname.type}
        </span>
        <span>,</span>
      </div>

      {/* <div>
        <span
          className={classes.timeLimitation}
          data-timelimitation={timeLimitation}
        >
          {caseSubname.timeLimitation}
        </span>
        {caseRarity !== '' && <span>,</span>}
      </div> */}
      <div>
        <span
          className={classes.rarity}
          data-caserarity={caseRarity}
        >
          {caseSubname.rarity}
        </span>
      </div>
    </div>
  )
}
